export const ENROLLMENT_PAGES = [
  {
    label: "Get started",
    page_number: 0,
    page_number_display: "1"
  },
  {
    label: "Create account",
    page_number: 1,
    page_number_display: "2"
  },
  {
    label: "Security",
    page_number: 2,
    page_number_display: "3"
  },
  {
    label: "Personal details",
    page_number: 3,
    page_number_display: "4"
  }, {
    label: "Brightwell card",
    page_number: 4,
    page_number_display: "5"
  },
  {
    label: "Communication",
    page_number: 6,
    page_number_display: "6"
  }
]
